<div class="fy-navigator" [class.disabled]="disabled">
  <button mat-icon-button
          class="fy-nav-button"
          type="button"
          [disabled]="!canGoBack"
          (click)="prev()"
          matTooltip="Previous fiscal year">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <span class="fy-label">FY {{ label }}</span>
  <button mat-icon-button
          class="fy-nav-button"
          type="button"
          [disabled]="!canGoForward"
          (click)="next()"
          matTooltip="Next fiscal year">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
